import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarGrupo from '../../components/modal/ModalCadastrarGrupo';
import ModalEditarGrupo from '../../components/modal/ModalEditarGrupo';
import ModalExcluirGrupo from '../../components/modal/ModalExcluirGrupo';
import { ServicoContext } from '../../context/ServicoContext';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function Grupo() {
    const { Success, Error, openModal, setOpenModal, GruposConsulta, ListaGrupoConsulta, modalEditarGrupo, setModalEditarGrupo, setEdicaoGrupo, setGrupoAtualKey, modalExcluirGrupo, setModalExcluirGrupo, InativarGrupo, Loading, ListaFiltroGrupo, totalRegistrosGrupo, filtroGrupo, totalRegistrosFiltroGrupo } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditGrupo = (props) => {
        setModalEditarGrupo(true)
        setGrupoAtualKey(props.key)
        setEdicaoGrupo(props)
    }

    const DeletarGrupo = (props) => {
        setGrupoAtualKey(props.key)
        setModalExcluirGrupo(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroGrupo(searchTerm, currentPage, pageSize);
        } else {
            ListaGrupoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroGrupo : totalRegistrosGrupo;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));


    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar Grupos'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarGrupo &&
                <ModalEditarGrupo currentPage={currentPage} />
            }
            {modalExcluirGrupo &&
                <ModalExcluirGrupo currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {Loading &&
                <LoadingScreen />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarGrupo closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar grupo</button>
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Grupos cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroGrupo : GruposConsulta}
                        columns={[
                            { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarGrupo(x.key, !x.ativo)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditGrupo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarGrupo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={Loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroGrupo(term, 1, 10);
                            } else {
                                ListaGrupoConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Grupo;